// Translate interaction type to Spanish
export const translateInteractionType = type => {
  const typeMap = {
    // Email
    email_sent: 'Email enviado',
    email_opened: 'Email abierto',
    email_response: 'Email respondido',
    // Calls
    call_made: 'Llamada realizada',
    call_received: 'Llamada recibida',
    call_missed: 'Llamada perdida',
    call_answered: 'Llamada contestada',
    call_voicemail: 'Buzón de voz',
    call_callback: 'Llamada de retorno',
    call_ended: 'Llamada finalizada',
    call_hungup: 'Llamada colgada',
    call_ringing_on_agent: 'Sonando en agente',
    call_agent_declined: 'Agente rechazó',
    call_transferred: 'Llamada transferida',
    call_external_transferred: 'Llamada transferida externamente',
    call_unsuccessful_transfer: 'Transferencia fallida',
    call_voicemail_left: 'Mensaje de voz dejado',
    call_commented: 'Llamada comentada',
    call_tagged: 'Llamada etiquetada',
    call_untagged: 'Etiqueta removida',
    call_assigned: 'Llamada asignada',
    call_archived: 'Llamada archivada',
    call_hold: 'Llamada en espera',
    call_unhold: 'Llamada reanudada',
    call_ivr_option_selected: 'Opción IVR seleccionada',
    // SMS
    sms_sent: 'SMS enviado',
    sms_opened: 'SMS abierto',
    sms_responded: 'SMS respondido',
    // WhatsApp
    whatsapp_sent: 'WhatsApp enviado',
    whatsapp_response: 'WhatsApp respondido',
    // Chat
    chat_entry: 'Entrada de chat',
    chat_response: 'Respuesta de chat',
    // Payment
    payment_received: 'Pago recibido',
    // URL Payment
    url_payment_opened_by_email: 'Enlace de pago abierto por email',
    url_payment_opened_by_sms: 'Enlace de pago abierto por SMS',
    url_payment_opened_by_chat: 'Enlace de pago abierto por chat',
    url_payment_opened_by_call: 'Enlace de pago abierto por llamada',
    url_payment_opened_by_whatsapp: 'Enlace de pago abierto por WhatsApp',
    url_payment_opened_by_other: 'Enlace de pago abierto',
  };
  return typeMap[type] || type;
};

